<template>
    <b-container class="pack-go-container" fluid>
        <div class="pack-go__cards-wrap">
            <p class="title-text">
                Pack & Go
            </p>
            <div class="pack-go__card">
                <div class="card-header">
                    <p class="title">
                        Order processing flow
                    </p>
                </div>
                <div class="d-flex card-body">
                    <div 
                        v-on:mouseover="scannerHover = true"
                        v-on:mouseleave="scannerHover = false" 
                        class="card-picker">
                        <div class="card-picker-button">
                            <Transition>
                                <div v-if="!scannerHover" class="card-picker-button-icon">
                                    <img src="~@/assets/pack_go/barcode-icon.svg" />
                                </div>
                                <div v-else class="card-picker-button-icon">
                                    <img src="~@/assets/pack_go/barcode-active-icon.svg" />
                                </div>
                            </Transition>

                            <div class="card-picker-action">
                                <router-link to="/pack-go/scanner">
                                    <button type="button" class="btn btn-primary w-100">Use Scanner Mode</button>
                                </router-link>
                                <p>
                                    Choose this option if you want to process orders using a picking list and a scanning device
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        v-on:mouseover="automaticModeHover = true"
                        v-on:mouseleave="automaticModeHover = false"  
                        class="card-picker">
                        <div class="card-picker-button">
                            <Transition>
                                <div v-if="!automaticModeHover" class="card-picker-button-icon">
                                    <img src="~@/assets/pack_go/automatic-mode-icon.svg" />
                                </div>
                                <div v-else class="card-picker-button-icon">
                                    <img src="~@/assets/pack_go/automatic-mode-active-icon.svg" />
                                </div>
                            </Transition>

                            <div class="card-picker-action">
                                <router-link to="/pack-go/automatic-mode">
                                    <button type="button" class="btn btn-primary w-100">Use Automatic Mode</button>
                                </router-link>
                                <p>
                                    Choose this option if you want to process orders using an automatic queue that fills from your incoming orders
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
import { BContainer } from "bootstrap-vue";

export default {
    components: {
        BContainer
    },
    data() {
        return {
            scannerHover: false,
            automaticModeHover: false
        }
    }
}
</script>

<style scoped>
    .pack-go-container {
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    @media only screen and (max-width: 991.98px) {
        .pack-go__cards-wrap {
            width: 100%;
            height: 70vh;
            margin-bottom: 50px;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            justify-content: center;
            align-items: center;
        }

        .card-picker {
            width: 50%;
            margin-left: 2px;
            margin-right: 2px;
            border-radius: 6px;
            transition: 0.5s;
        }

        .card-body {
            margin-top: 5px;
            padding-left: 10px;
            padding-right: 10px;
            margin-bottom: 39px;
        }
    }

    @media only screen and (min-width: 992px) {
        .pack-go__cards-wrap {
            width: 70%;
            height: 70vh;
            margin-bottom: 50px;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            justify-content: center;
            align-items: center;
        }

        .card-picker {
            width: 50%;
            margin-left: 15px;
            margin-right: 15px;
            border-radius: 6px;
            transition: 0.5s;
        }

        .card-body {
            margin-top: 43px;
            padding-left: 25px;
            padding-right: 25px;
            margin-bottom: 39px;
        }
    }

    .pack-go__card {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        margin-top: 22px;
        background-color: #ffffff;
        border: 1px solid #C3C5C7;
        border-radius: 6px;
    }

    .title-text {
        font-family: "SourceSansProSemibold";
        font-style: normal;
        font-weight: 600;
        font-size: 31px;
        width: 100%;
    }

    .card-header {
        padding: 18px, 20px;
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        background-color: #ffffff;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        border-bottom: 1px solid #C3C5C7;
    }

    .card-header .title {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        margin-top: auto;
        margin-bottom: auto;
    }

    .card-header .action-div {
        display: flex;
        align-items: center;
    }

    .card-header-action {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        margin-top: auto;
        margin-bottom: auto;
        color: #1D97FF;
    }

    .card-picker-button {
        border: 1px solid #F1F1F1;
        border-radius: 6px;
        padding-top: 33px;
    }

    .card-picker-button-icon {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .card-picker-action {
        margin-top: 32px;
        padding: 0px 20px;
    }

    .card-picker-action button {
        background-color: #ffffff;
        color: #112857;
        border: 1px solid #112857;
        border-radius: 6px;
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        height: 44px;
    }

    .card-picker-action button:hover {
        background-color: #112857;
        color: #ffffff;
    }

    .card-picker-action p {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 15px;
        line-height: 23px;
        color: #8E9298;
        text-align: center;
        margin-top: 14px;
        margin-bottom: 37px;
    }

    .card-picker:hover {
        background-color: #E7E7E7;
    }

    .card-picker:hover .card-picker-button .card-picker-action p {
        color: #212121;
    }

    .v-enter-active,
    .v-leave-active {
    transition: opacity 0.8s ease;
    }

    .v-enter-from,
    .v-leave-to {
    opacity: 0;
    }
</style>